// extracted by mini-css-extract-plugin
module.exports = {"img":"ImageColumn_img_208Px"};